import Swiper from 'swiper';
import {Pagination, EffectFade} from "swiper/modules";

import 'swiper/css';
import 'swiper/css/effect-fade'

import _ from '@app/utils.js'

_.onElementReady('.page-node-type-sustainability .swiper', el => {
  const swiper = new Swiper(el, {
    modules: [Pagination, EffectFade],
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
})
